import { axiosApi as axios } from '../helpers/axiosApi';
import { getCookie } from './helpers';
const COMMERCIAL_PRODUCTS_API = "/studies/commercial-products/";

export const getCommercialProducts = (params) => {
  return axios.get(COMMERCIAL_PRODUCTS_API, {params: params}).then(res => res.data.data);
}

export const addCommercialProduct = (params) => {
  let payload = params
  return axios.post(COMMERCIAL_PRODUCTS_API, payload, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => res.data);
}

export const updateCommercialProduct = (id, body) => {
  return axios.put(`${COMMERCIAL_PRODUCTS_API}${id}/`, body, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => res.data);
}

export const deleteCommercialProduct = (id) => {
  return axios.delete(`${COMMERCIAL_PRODUCTS_API}${id}/`, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => res);
}
